const Loading = ({fullHeight=true}) =>
{
	const height = fullHeight ? '-mt-10 h-screen fa-4x' : 'my-5 fa-3x';
	return(
		<div className={'bg-lightBG flex justify-center items-center dark:bg-darkBG '+height}>
			<i className='block fa fa-circle-notch fa-spin text-primary'></i>
		</div>
	);
}

export default Loading;